<div class="yr-section">
    <div class="year-toggle-buttons">
        <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate" (click)="toggleYears('-')"
            role="img">keyboard_arrow_left</mat-icon>
        <mat-label>{{selectedDate.year()}}</mat-label>
        <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate" (click)="toggleYears('+')"
            role="img">keyboard_arrow_right</mat-icon>
    </div>
</div>